import axios from "axios";

export default axios.create({
  baseURL: "https://savermiddleeast.com/wp-json/api/v2",
  // baseURL: "https://savermiddleeast.360southclients.com/wp-json/api/v2",
});
